import { Link, Outlet } from "react-router-dom";

export const NavbarComponent = () => {
    return (<nav className="navbar navbar-expand-lg navbar-dark" style={{"backgroundColor": "#000"}}>
        <div className="container-fluid">
            <div className="collapse navbar-collapse justify-content-center" id="navbarSupportedContent">
                <ul className="navbar-nav mb-2 mb-lg-0">
                    <li className="nav-item">
                        <Link to="/" className="nav-link">
                            HOME
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/about" className="nav-link">
                            SOBRE
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link to="/franchisee" className="nav-link">
                            FRANQUEADO
                        </Link>
                    </li>
                </ul>
            </div>
        </div>
    </nav>);
}